// Section 22 main screen: persistent header, then left panel (people), centre (tabs) and right
// panel (stocks, projection, warnings). Tab moves through the panels in that order.
import type { ComponentChildren } from 'preact';
import { uiText } from '../text/en';
import './shell.css';

interface Props {
  header: ComponentChildren;
  notices: ComponentChildren;
  left: ComponentChildren;
  centre: ComponentChildren;
  right: ComponentChildren;
}

export function Layout({ header, notices, left, centre, right }: Props) {
  return (
    <div class="shell">
      <a class="skip" href="#work">
        {uiText.app.skipToMain}
      </a>
      {header}
      <div class="shell__notices">{notices}</div>
      <div class="shell__body">
        <div class="shell__left">{left}</div>
        <div class="shell__centre">{centre}</div>
        <div class="shell__right">{right}</div>
      </div>
    </div>
  );
}
